

// language
import { injectIntl, IntlShape } from 'react-intl';

// redux
import { useSelector } from 'react-redux';

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";

// types
import { ReservationData, } from 'types/typesRedux';

// icons
import { reservationIconWhite } from 'assets/icons'
import EditIcon from '@mui/icons-material/Edit';

interface Props {
  intl: IntlShape,
  onSubmitEdit?: (bool: boolean) => void,
}

function FineInfo( { intl, onSubmitEdit } :Props ): JSX.Element {

  const reservation = useSelector( (state: ReservationData) => state.reservationDetail.reservation )

  const handleStatusColor = () => {
    if ( reservation.fineStatus === intl.formatMessage({ id: 'fines.detail.awaiting_payment' }) ) {
      return '#F5A524';
    } else if ( reservation.status === intl.formatMessage({ id: 'fines.detail.paid' }) ) {
      return '#309B0A';
    } 
  }
     
  return (
    <>
      <MDBox        
        sx= {{ width: "25rem", display: "flex",
          flexDirection: "column",
          padding: "0.8rem 1.5rem", backgroundColor: "#ffffff",
          borderRadius: "0.75rem",
        }}
      >

        <MDBox 
          sx= {{ 
            width: "100%", display: "flex", flexDirection: "row", 
            justifyContent: "flex-start",
          }}
        >
          <MDBox className= "badge"
            sx={{ 
              // backgroundColor: "#17C063",
              p: 1, mt: -4, ml: 0,
              borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
            }}
              display="grid"
              justifyContent="center"
              alignItems="center"
              bgColor="#17C063"
              color="white"
              width="4.5rem"
              height="4.5rem"
              shadow="md"
              borderRadius="lg"
              variant="gradient"  
              fontSize= "2.2rem"        
          >
            {reservationIconWhite}
          </MDBox>

          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              flex: 1, justifyContent: "space-between",
            }}
          >
            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                alignItems: "flex-start", marginLeft: "1rem",
                justifyContent: "center",
              }}
            >
              <MDTypography
                sx={{
                  fontSize: "1.2rem", fontWeight: "700",
                }}
              >
                {intl.formatMessage({id:'reservationDetailFine.title'})}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "400",
                  color: handleStatusColor(), marginTop: "-0.2rem",
                }}
              >
                {reservation.fineStatus}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                alignItems: "flex-end", marginLeft: "1rem",
                justifyContent: "center",
              }}
            >
              <MDTypography
                sx={{
                  fontSize: "0.625rem", fontWeight: "400",
                }}
              >
                {reservation.fineCreatedAt}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.625rem", fontWeight: "400",
                  color: "#807E7B", marginTop: "0.2rem",
                }}
              >
                {reservation.fineId}
              </MDTypography>
            </MDBox>

          </MDBox>

        </MDBox>

        <Divider
          orientation="horizontal"
          flexItem
          sx={{ 
            width: '100%', height: '1px', marginTop: "0.3rem", 
            marginBottom: "0rem", background: 'black',
          }}
        /> 

        <MDBox
          sx={{
            display: "flex", flexDirection: "row",
            justifyContent: "space-between", marginTop: "0.3rem",
          }}
        >
          <MDBox
            sx={{
              display: "flex", flexDirection: "column",
            }}
          >
            <MDTypography
              sx={{
                fontSize: "0.625rem", fontWeight: "400",
                color: "#807E7B"
              }}
            >
              {intl.formatMessage({id:'reservationDetailFine.description'})}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "700",
                // color: handleColorStatus(),
              }}
            >
              {reservation.fineDescription}
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              display: "flex", flexDirection: "column",
            }}
          >
            <MDTypography
              sx={{
                fontSize: "0.625rem", fontWeight: "400",
                color: "#807E7B"
              }}
            >
              {intl.formatMessage({id:'reservationDetailFine.price'})}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "700",
                // color: handleColorStatus(),
              }}
            >
              {reservation.fineAmount} {intl.formatMessage({id:'currency'})}
            </MDTypography>
          </MDBox>
        </MDBox>

      </MDBox>
    </>
  );
}

export default injectIntl(FineInfo);
